import { render } from "./CASIQuestions.vue?vue&type=template&id=31bb7bc8&scoped=true"
import script from "./CASIQuestions.vue?vue&type=script&lang=js"
export * from "./CASIQuestions.vue?vue&type=script&lang=js"

import "./CASIQuestions.vue?vue&type=style&index=0&id=31bb7bc8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31bb7bc8"]])

export default __exports__